import { HeaderStrapiProps } from '@/decodo/features/Header/transformer';
import { getStory } from './getStory';
import { tags } from './tags';
import { Entry, EntryVersion, GetStoryResult, TopicEntry } from '../types';
import { FooterStrapiProps } from '@/decodo/blocks/Footer/FooterStrapi';
import { getEntries } from '..';

export const cms = {
  getBlogBySlug: (slug: string, status?: EntryVersion) =>
    getStory({
      apiPath: '/blogs',
      slug,
      tags: ['blogs', tags.blogBySlug(slug)],
      status,
    }),

  getPageBySlug: (slug: string, status?: EntryVersion) =>
    getStory({
      apiPath: '/pages',
      slug,
      tags: ['pages', tags.pageBySlug(slug)],
      status,
    }),

  getTopicBySlug: (slug: string, status?: EntryVersion) =>
    getStory({
      apiPath: '/blog-topics',
      slug,
      tags: ['blog-topics', tags.blogTopicBySlug(slug)],
      status,
    }),

  getHeaderByDocumentId: (
    documentId: string,
    status?: EntryVersion
  ): Promise<GetStoryResult<HeaderStrapiProps>> =>
    getStory({
      apiPath: '/headers',
      documentId,
      tags: ['headers', tags.headerByDocId(documentId)],
      status,
    }),

  getFooterByDocumentId: (
    documentId: string,
    status?: EntryVersion
  ): Promise<GetStoryResult<FooterStrapiProps>> =>
    getStory({
      apiPath: '/footers',
      documentId,
      tags: ['footers', tags.footerByDocId(documentId)],
      status,
    }),

  getAllTopicLabels: () =>
    getEntries<TopicEntry>({
      apiPath: '/blog-topics',
      query: {
        sort: 'topic:asc',
        pagination: {
          start: 0,
          limit: 100,
        },
        pLevel: '1',
      },
      next: {
        tags: ['blog-topics'],
      },
    }),

  getLatestBlogpost: () =>
    getEntries<Entry>({
      apiPath: '/blogs',
      query: {
        pLevel: '1',
        sort: 'metadata.releaseDate:desc',
        pagination: {
          start: 0,
          limit: 1,
        },
      },
      next: {
        tags: ['blogs', 'latest-blogpost'],
      },
    }),
};
